// create
export const CREATE_BANK_MASTER_REQUEST = "CREATE_BANK_MASTER_REQUEST";
export const CREATE_BANK_MASTER_SUCCESS = "CREATE_BANK_MASTER_SUCCESS";
export const CREATE_BANK_MASTER_FAIL = "CREATE_BANK_MASTER_FAIL";

// get
export const BANK_MASTER_REQUEST = "BANK_MASTER_REQUEST";
export const BANK_MASTER_SUCCESS = "BANK_MASTER_SUCCESS";
export const BANK_MASTER_FAIL = "BANK_MASTER_FAIL";

// find
export const FIND_BANK_MASTER_REQUEST = "FIND_BANK_MASTER_REQUEST";
export const FIND_BANK_MASTER_SUCCESS = "FIND_BANK_MASTER_SUCCESS";
export const FIND_BANK_MASTER_FAIL = "FIND_BANK_MASTER_FAIL";

// update
export const UPDATE_BANK_MASTER_REQUEST = "UPDATE_BANK_MASTER_REQUEST";
export const UPDATE_BANK_MASTER_SUCCESS = "UPDATE_BANK_MASTER_SUCCESS";
export const UPDATE_BANK_MASTER_FAIL = "UPDATE_BANK_MASTER_FAIL";

// delete
export const DELETE_BANK_MASTER_REQUEST = "DELETE_BANK_MASTER_REQUEST";
export const DELETE_BANK_MASTER_SUCCESS = "DELETE_BANK_MASTER_SUCCESS";
export const DELETE_BANK_MASTER_FAIL = "DELETE_BANK_MASTER_FAIL";

export const CLEAR_ERROR = "CLEAR_ERROR";
